// @flow
import React from 'react';

import Card, { CardHeader, CardText } from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import FontIcon from 'material-ui/FontIcon';
import List, { ListItem } from 'material-ui/List';

import { cyan50, cyan100, cyan500, cyan600 } from 'material-ui/styles/colors';

const CONTACT_METHODS = [
  {
    icon: 'mail',
    label: 'legter@legter.hu',
    href: 'mailto:legter@legter.hu',
  },
];

const getStyles = ({ isMobile }) => ({
  card: isMobile
    ? {}
    : {
        margin: 0,
        marginLeft: -20,
        flex: 1,
        transform: 'scale(.95)',
        opacity: 0.9,
        border: `1px solid ${cyan100}`,
      },

  list: {},

  header: {
    background: cyan50,
  },

  title: {
    color: cyan600,
    fontSize: 14,
    paddingTop: 10,
    paddingBottom: 6,
    marginLeft: 32,
    marginRight: -90,
    minWidth: 200,
  },

  subtitle: {
    color: cyan500,
  },

  item: {
    paddingLeft: 24,
    color: cyan600,
  },

  text: {
    display: 'inline-block',
    fontSize: 14,
    color: cyan600,
    verticalAlign: '40%',
    marginLeft: 8,
  },
});

const renderContactMethod = ({ icon, label, href }, styles) => (
  <ListItem
    key={`contactMethod-${icon}`}
    style={styles.item}
    primaryText={label}
    onClick={() => window.location.assign(href)}
    leftAvatar={
      <Avatar
        icon={<FontIcon className="material-icons">{icon}</FontIcon>}
        color="white"
        backgroundColor={cyan500}
      />
    }
  />
);

export default ({ browser }) => {
  const isMobile = browser.lessThan.medium;
  const styles = getStyles({ isMobile });

  return (
    <Card style={styles.card} zDepth={0}>
      <CardHeader
        style={styles.header}
        titleStyle={styles.title}
        title="További kapcsolatfelvételi lehetőségek"
      />
      <List style={styles.list}>
        {CONTACT_METHODS.map(cm => renderContactMethod(cm, styles))}
      </List>
    </Card>
  );
};



// WEBPACK FOOTER //
// ./components/SearchResultsDialog/ContactMethodList.js